import { Formatters } from '../modules'

export default {
  props: {
    state: {
      label: '状态',
      type: 'state',
    },
    customers_summary: {
      label: '租户',
      classes: 'hide-in-mobile',
      formatter(_, record) {
        let customers = []
        if (record) {
          if (record._customers && typeof record._customers[0] === 'string')
            customers = this.$store.getters.customers_filter(record._customers)
          else
            customers = record._customers
        }
        return Formatters.customers_summary(customers)
      },
    },
    date_start: {
      label: '合同起始',
      type: 'date',
      classes: 'hide-in-tablet',
    },
    date_end: {
      label: '合同结束',
      type: 'date',
    },
    pay_unit_month: {
      label: '租金方式',
      formatter: Formatters.pay_unit_month,
    },
    date_expire: {
      label: '租金到期',
      type: 'date',
    },
    price_month: {
      label: '租金 / 月',
      type: 'money',
      classes: 'hide-in-mobile',
    },
    management_fee_month: {
      label: '管理费 / 月',
      type: 'money',
      classes: 'hide-in-tablet',
    },
    network_fee_month: {
      label: '网络费 / 月',
      type: 'money',
      classes: 'hide-in-tablet',
    },
    deposit_money: {
      label: '押金',
      type: 'money',
      classes: 'hide-in-tablet',
    },
    note: {
      label: '备注',
      classes: 'hide-in-tablet',
      maxlength: 10,
      tooltip: 'top center',
    },
  },
  actions: {
    goto: {
      icon: 'external square',
      tooltip: '合同详情',
    },
  },
  layouts: {
    default: {
      layout: [
        'state',
        'customers_summary',
        'date_start',
        'date_end',
        'pay_unit_month',
        'date_expire',
        'price_month',
        'deposit_money',
        'note',
      ],
    },
    detail: {
      layout: [
        'state',
        'customers_summary',
        'date_start',
        'date_end',
        'pay_unit_month',
        'date_expire',
        'price_month',
        'management_fee_month',
        'network_fee_month',
        'deposit_money',
        'note',
      ],
    },
  },
}



// WEBPACK FOOTER //
// ./client/src/defines/contract.js